/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Card, Title, Loader } from 'shared-components';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';
import {
  AppIncident,
  IncidentTooltipHeader,
  Seperator,
  SystemStatusHeader,
  TimezoneDisclaimer,
} from '../styles';
import Incident from '../Incident';
import useTellerApi from '../../../hooks/useTellerApi';
import ClientErrorComponent from '../../../components/ClientErrorComponent';
import { extendIncidents, formatDate } from '../helper';
import { STATUSCATEGORIES } from '../../../utils/config';

function AppStatus({ pastIncidents }) {
  const [collpased, setCollpased] = useState(false);
  const today = new Date();
  const endDate = today.toISOString().split('T')[0];

  const pastDate = new Date(today);
  pastDate.setDate(today.getDate() - 89); // 90 days total including today
  const startDate = pastDate.toISOString().split('T')[0];
  const [
    {
      data: { services, status },
    },
  ] = useTellerApi('/api/v1/client_portal/uptimes/status', {});
  const [
    {
      data: { services: uptimes, uptime },
      isLoading,
      isError,
    },
  ] = useTellerApi(
    `/api/v1/client_portal/uptimes?start_date=${startDate}&end_date=${endDate}`,
    {}
  );
  const latestServices = services || [];
  return (
    <div>
      <SystemStatusHeader>
        <Title>System Status</Title>
        <TimezoneDisclaimer>
          <svg
            width="24"
            height="24"
            viewBox="0 0 30.72 30.72"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.56 5.76 10.88 3.2 3.2 5.76v20.48l7.68-2.56 7.68 2.56 7.68-2.56V3.2z"
              fill="#FFECB3"
            />
            <path d="M10.88 3.2v20.48l7.68 2.56V5.76z" fill="#FFD54F" />
            <path
              d="M27.52 19.84a7.68 7.68 0 1 1-15.361-.001 7.68 7.68 0 0 1 15.361.001"
              fill="#00ACC1"
            />
            <path
              d="M25.6 19.84a5.76 5.76 0 1 1-11.52 0 5.76 5.76 0 0 1 11.52 0"
              fill="#EEE"
            />
            <path d="M19.2 15.36h1.28v4.48H19.2z" />
            <path d="m19.409 20.271.863-.863 2.431 2.432-.863.863z" />
            <path d="M20.8 19.84a.96.96 0 1 1-1.921-.001.96.96 0 0 1 1.921.001" />
          </svg>
          Note: All times are displayed in UTC (Coordinated Universal Time).
        </TimezoneDisclaimer>
      </SystemStatusHeader>
      <Card className="mb-3">
        {isLoading && <Loader />}
        {!isLoading && isError && <ClientErrorComponent data={{}} />}
        {!isLoading && !isError && (
          <>
            <AppIncidentDetails
              isDefault
              collpased={collpased}
              setCollpased={setCollpased}
              item={{
                name: 'All Services',
                uptime,
                category: status,
              }}
              pastIncidents={pastIncidents}
            />
            {collpased && <Seperator />}

            {collpased &&
              uptimes.map((item, index) => (
                <div key={item.id}>
                  <AppIncidentDetails
                    item={{
                      ...item,
                      category:
                        latestServices.find(s => s.id === item.id).category ||
                        'operational',
                    }}
                  />
                  {index < uptimes.length - 1 && <Seperator />}
                </div>
              ))}
          </>
        )}
      </Card>
    </div>
  );
}

export default AppStatus;

// eslint-disable-next-line react/prop-types
function IncidentItem({ incident }) {
  const [activeItem, setactiveItem] = useState(0);
  const isMultiple = incident.incidents && incident.incidents.length > 1;
  const incidentDate = new Date(incident.date);
  const formattedDate = incidentDate.toLocaleString('en-US', {
    timeZone: 'UTC',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const tooltipcontent = (
    <div>
      <IncidentTooltipHeader>
        <p className="tooltip-header-date">{formattedDate}</p>
        {isMultiple && (
          <div className="tooltip-header-actions">
            <p>
              {activeItem + 1} of {incident.incidents.length} incidents
            </p>
            <div className="action-items">
              <button
                type="button"
                onClick={() => setactiveItem(prev => prev - 1)}
                disabled={activeItem === 0}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  xmlSpace="preserve"
                  width="12"
                  height="12"
                >
                  <path d="M5.392 8 12.151 1.242c0.284 -0.284 0.284 -0.745 0 -1.029s-0.745 -0.284 -1.029 0L3.849 7.486a0.727 0.727 0 0 0 -0.213 0.514 0.728 0.728 0 0 0 0.213 0.514l7.273 7.273c0.142 0.142 0.328 0.213 0.514 0.213s0.372 -0.071 0.514 -0.213c0.284 -0.284 0.284 -0.745 0 -1.029z" />
                </svg>
              </button>
              <button
                type="button"
                onClick={() => setactiveItem(prev => prev + 1)}
                disabled={activeItem === incident.incidents.length - 1}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  xmlSpace="preserve"
                  width="12"
                  height="12"
                >
                  <path d="M12.151 7.486 4.878.213A.727.727 0 1 0 3.85 1.241l6.758 6.758-6.759 6.759a.727.727 0 0 0 0 1.028.73.73 0 0 0 .515.214.73.73 0 0 0 .514-.213l7.273-7.273a.727.727 0 0 0 0-1.029" />
                </svg>
              </button>
            </div>
          </div>
        )}
      </IncidentTooltipHeader>
      {incident.id ? (
        <>
          {incident.incidents && (
            <Incident incident={incident.incidents[activeItem]} />
          )}
        </>
      ) : (
        <Incident incident={incident} />
      )}
    </div>
  );

  const successCategories = ['operational', 'maintenance'];
  const isOperational =
    incident.incidents && incident.incidents.length > 0
      ? incident.incidents.every(i => successCategories.includes(i.category))
      : true; // Default to true if no incidents
  return (
    <Tooltip
      title={formattedDate}
      position="bottom"
      trigger="mouseenter focus"
      interactive
      interactiveBorder={10}
      delay={1}
      arrow
      html={tooltipcontent}
      theme="light"
      tabIndex={0}
    >
      <div className={`incidentitem ${isOperational ? 'up' : ' down'}`} />
    </Tooltip>
  );
}

// eslint-disable-next-line react/prop-types
function AppIncidentDetails({
  item,
  pastIncidents,
  setCollpased,
  collpased,
  isDefault,
}) {
  const allincidents = extendIncidents(pastIncidents || item.incidents, 90);
  const today = formatDate(new Date());
  const averageUptimePercentage = item.uptime || 0;
  const CurrentDayStatus = item.category || 'operational';
  const CurrentDayStatusTitle = STATUSCATEGORIES.find(
    item => item.id === CurrentDayStatus
  ).name;
  return (
    <AppIncident>
      <div className="incident-header">
        <div className="incident-title">
          {isDefault && (
            <button
              type="button"
              className="incident-collapse-btn"
              onClick={() => setCollpased(!collpased)}
              style={{ height: '25px', width: '25px' }}
              title="View all services"
            >
              {collpased ? '-' : '+'}
            </button>
          )}
          <p title={item.description}>{item.name}</p>
        </div>
        <p className={`incident-status ${CurrentDayStatus || ''}`}>
          {CurrentDayStatusTitle}
        </p>
      </div>
      <div className="incident-chart">
        {allincidents.map(item => (
          <IncidentItem
            incident={item}
            className="incidentitem up"
            key={Math.random()}
          />
        ))}
      </div>
      <div className="incident-timings">
        <p title={allincidents[0].date}>90 days ago</p>
        <div className="seperator-horizontal" />
        <p>{averageUptimePercentage.toFixed(2)}% uptime</p>
        <div className="seperator-horizontal" />
        <p title={today}>Today</p>
      </div>
    </AppIncident>
  );
}
